import React, { useEffect, useState } from "react";
import MainCard from "components/MainCard";
import { Table, Spin, Pagination } from "antd";
import { connect } from "react-redux";
import { Grid, Button } from "@mui/material";
import { IoMdAddCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { dispatch } from "store/index";
import { compaignsColumns } from "components/columns/columns";
import { FetchAllCompaigns, FetchWhatsappChannel } from "store/action/index";
import DrawerRight from "../../components/drawer/AddCampaignDrawer";

const AllCampaigns = ({ allcompaigns }) => {
  const [loading, setLoading] = useState(true);
  const [params, setparams] = useState({ page: 1 });
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    dispatch(FetchAllCompaigns({ setLoading: setLoading, params: params }));
  }, [params]);

  const handleNavigate = (record) => {
    navigate("/activities/all-activities", { state: record });
  };

  const columns = compaignsColumns({ params, setparams, handleNavigate });

  const handlePageChange = (page) => {
    setparams({ ...params, page });
  };

  return (
    <>
      <div className="mb-4">
        <MainCard>
          <div style={{ display: "flex" }}>
            <Grid container alignItems="center" justifyContent="flex-start">
              <Grid item>
                <span
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                  }}
                >
                  All Campaigns
                </span>
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="flex-end">
              <Grid item>
                <DrawerRight>
                  <Button
                    disableElevation
                    className="px-2"
                    size="large"
                    type="submit"
                  >
                    <span className="mx-2">
                      <IoMdAddCircle color="#0055A2" size={26} />
                    </span>
                    Add Campaign
                  </Button>
                </DrawerRight>
              </Grid>
            </Grid>
          </div>
        </MainCard>
      </div>

      <MainCard>
        <div style={{ overflowX: "auto" }}>
          <Table
            dataSource={allcompaigns?.data ?? []}
            columns={columns}
            pagination={false}
            loading={loading}
            rowKey="id"
          />
        </div>
        <div style={{ textAlign: "center", marginTop: 16 }}>
          <Pagination
            current={allcompaigns?.meta?.current_page || 1}
            total={allcompaigns?.meta?.total || 0}
            pageSize={allcompaigns?.meta?.per_page || 10}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
      </MainCard>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    allcompaigns: state?.AllCompainReducer?.allcompaigns,
  };
};

export default connect(mapStateToProps)(AllCampaigns);
